import { render, staticRenderFns } from "./MagicWand.vue?vue&type=template&id=a1bce474&scoped=true&"
import script from "./MagicWand.vue?vue&type=script&lang=js&"
export * from "./MagicWand.vue?vue&type=script&lang=js&"
import style0 from "./MagicWand.vue?vue&type=style&index=0&id=a1bce474&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1bce474",
  null
  
)

export default component.exports